import { ChordStackIcon } from './ChordStackIcon';
import type { MeasureChordSummary } from '../utils/chordAccompaniment';

interface Props {
  summary: MeasureChordSummary;
  measureIndex: number;
  onClick: () => void;
}

export function MeasureChordButton({ summary, measureIndex, onClick }: Props) {
  const title = summary.hasChords
    ? `Armonía: ${summary.displayName} — compás ${measureIndex + 1}`
    : `Añadir armonía al compás ${measureIndex + 1}`;

  return (
    <button
      type="button"
      className={`measure-block__chord ${summary.hasChords ? 'measure-block__chord--active' : ''}`}
      onClick={onClick}
      aria-label={title}
      title={title}
    >
      <ChordStackIcon
        active={summary.hasChords}
        chordId={summary.primaryChordId}
        className="measure-block__chord-icon"
      />
      <span className="measure-block__chord-name">{summary.displayName}</span>
    </button>
  );
}
